import { useCallback, useRef, useState } from "react";
import { useCopyToClipboard as useCopy } from "react-use";

export interface CopyToClipboardState {
  value?: string;
  noUserInteraction: boolean;
  error?: Error;
  copied: boolean;
}

export type CopyToClipboardFn = (value: string) => void;

export type UseCopyToClipboardResult = [
  CopyToClipboardState,
  CopyToClipboardFn
];

export function useCopyToClipboard(): UseCopyToClipboardResult {
  const [state, copy] = useCopy();
  const [copied, setCopied] = useState(false);
  const ref = useRef(0);

  const copyToClipboard: CopyToClipboardFn = useCallback(
    (data: string) => {
      if (ref.current) window.clearTimeout(ref.current);

      setCopied(true);
      copy(data);

      ref.current = window.setTimeout(() => setCopied(false), 500);
    },
    [copy]
  );

  const finalState = {
    ...state,
    copied: !!(copied && state.value && !state.error),
  };

  return [finalState, copyToClipboard];
}
